import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/imgcaptions/officialIco.svg'
import _imports_1 from '@/assets/sound/play.png'
import _imports_2 from '@/assets/sound/pause.png'
import _imports_3 from '@/assets/aivoice/pic_kongyinpin.svg'
import _imports_4 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "marketBox" }
const _hoisted_2 = { class: "marketTitle" }
const _hoisted_3 = { class: "marketTopType" }
const _hoisted_4 = {
  key: 0,
  class: "typeOneLine"
}
const _hoisted_5 = {
  key: 0,
  class: "typeOneLine"
}
const _hoisted_6 = { class: "marketPrompt" }
const _hoisted_7 = { class: "roleListBox" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "roleOneTitle"
}
const _hoisted_10 = {
  key: 1,
  class: "roleOneTitleMian"
}
const _hoisted_11 = { class: "head" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "timbreOneImg" }
const _hoisted_14 = { class: "picBom" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "playBtn"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "playBtn"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "timbreOneName" }
const _hoisted_21 = { class: "timbreOneTitle" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "dataNO"
}
const _hoisted_24 = { class: "marketBtn" }
const _hoisted_25 = { class: "btnBox" }
const _hoisted_26 = { class: "pieceBoxmask" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted,getCurrentInstance,onUnmounted ,watch} from 'vue'
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
//接口引入
import depotApi from "@/api/sound/depot.ts";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'timbreMarket',
  props: {
    isChange:Boolean
},
  emits: ['closeThis','recognition'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance();
const props = __props
const checkStyle={
    color:'#fff'
}
const showFrom=ref(false)
const user=ref()

onMounted(()=>{
    getRole()
    // marketList.value=JSON.parse(localStorage.getItem('marketList'))||[]
    // checkData.value=null
    // user.value=JSON.parse(localStorage.getItem('user'))
})
onUnmounted(()=>{
    audioRef.value?.pause()
})

// 选择角色
const checkData=ref()
const checkDataIndex=ref(-1)
const checkStyleData={
    border: '1px solid #17B067'
}
const checkRoles=(data:any,index:number)=>{
    checkData.value=data
    checkDataIndex.value=index
}
const checkType=ref('public')
// 获取角色
const pageNum=ref(1)
const pageSize=ref(300)
const roleList=ref([])
const showRoleList=ref([])
// 公开角色
const getRole=()=>{
    if(props.isChange){//为true查询能变声角色
        depotApi.getListFinishChange(pageNum.value, pageSize.value,1,1,100).then((res) => {
    
            res.rows.forEach((item:any )=> {
                item.isPlaying=false
                showRoleList.value.push(item)
            });

        console.log(showRoleList.value)
        });
    } else{
        depotApi.getList(pageNum.value, pageSize.value,1).then((res) => {
    
                res.rows.forEach((item:any )=> {
                    item.isPlaying=false
                    showRoleList.value.push(item)
                });
            
            console.log(showRoleList.value)
        });
    }
   
}
// 我的角色
const getRoleMy=()=>{
    if(props.isChange){//为true查询能变声我的角色
        depotApi.getisMyFinishChange(pageNum.value, pageSize.value,true,100,1).then((res) => {
            
            res.rows.forEach((item:any )=> {
                item.isPlaying=false
                showRoleList.value.push(item)
            });

        console.log(showRoleList.value)
        });
    } else{
        depotApi.getisMyList(pageNum.value, pageSize.value,true).then((res) => {
    
                res.rows.forEach((item:any )=> {
                    item.isPlaying=false
                    showRoleList.value.push(item)
                });
            
            console.log(showRoleList.value)
        });
    }
   
}
// 播放
const playIndex=ref(-1)
const urlListening=ref('')
const audioRef=ref()
const showlodaing=ref(false)
const selData=ref()
const toPlay =(data:any,index:number)=>{
    console.log(index)
    showRoleList.value.forEach((item:any )=> {
        item.isPlaying=false
    });
    playIndex.value=index
    if(selData.value == null || data.roleId!=selData.value.roleId){
        selData.value=data
        // showlodaing.value=true
        if(data.demoAudio==undefined){
            depotApi.roleListening(showRoleList.value[index].roleId).then(res=>{
                console.log(res)
                if(res.code==200){
                    urlListening.value=res.msg
                    setTimeout(()=>{
                        showlodaing.value=false
                        showRoleList.value[index].isPlaying=true
                        audioRef.value?.play()
                    },100)
                }
                
            }).catch(err=>{
                showlodaing.value=false
                
            })
        }else{
            urlListening.value=data.demoAudio
            setTimeout(()=>{
                showlodaing.value=false
                showRoleList.value[index].isPlaying=true
                audioRef.value?.play()
            },100)
        }
        
    }else {
            showlodaing.value=false
            showRoleList.value[index].isPlaying=true
            audioRef.value?.play()   
        }

}
// 暂停
const topause=(index:number)=>{
    showRoleList.value[index].isPlaying=false
    audioRef.value?.pause()
}
const updateCurrentTime = () => {
    showRoleList.value[playIndex.value].isPlaying=false
    audioRef.value?.pause()
}
// 选择类型
const checkTypeFun=(type:string)=>{
    checkType.value=type
    showRoleList.value=[]
    if(type=='public'){
        getRole()
    }else{
        getRoleMy()
    }
}
// 点赞
// const likeFun=(data:any,index:number)=>{
//     roleAivoice.likeTo(data.roleId).then(res=>{
//         console.log(res)
//         if(res.code==200){
//             showRoleList.value[index].likes+=1
//         }
//     })
// }
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}

const tolanguage = ref('')
const fromlanguage=ref('')
const marketList=ref([])
const handleClose = () => {
    
    if(!props.isChange&&checkData.value.voiceChangeEnable==1&& checkData.value.trainingStatus!=100){
        console.log(checkData.value)
        ElMessage({
            type: 'error',
            message: '该变声角色没有训练完成' ,
        })
        return
    }else{
        emit('recognition',JSON.stringify(checkData.value))
        emit('closeThis')
    }
    


    // if(checkData.value!=null){
    //     let num=marketList.value.findIndex(item=>item.roleId==checkData.value.roleId)
    //     // console.log(num)
    //     if(num<0){
    //         marketList.value.unshift(checkData.value)
    //         localStorage.setItem('marketList',JSON.stringify(marketList.value))
    //         emit('closeThis')
    //     }else{
    //         let item = marketList.value.splice(num, 1)[0]; // 从数组中移除该项并获得它
    //         // console.log(item)
    //         marketList.value.unshift(item)
    //         // console.log(marketList.value)
    //         localStorage.setItem('marketList',JSON.stringify(marketList.value))
    //         emit('closeThis')
    //     }
        
    // }
   
}



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "typeOne",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (checkTypeFun('public')), ["stop"]))
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle(checkType.value=='public'?checkStyle:'')
          }, "公开", 4),
          (checkType.value=='public')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "lineOne" }, null, -1)),
        _createElementVNode("div", {
          class: "typeOne",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (checkTypeFun('isMy')), ["stop"]))
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle(checkType.value=='isMy'?checkStyle:'')
          }, "我的", 4),
          (checkType.value=='isMy')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closeBox, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (showRoleList.value.length>0)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showRoleList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "roleOne",
                    key: index,
                    style: _normalizeStyle(checkDataIndex.value==index?checkStyleData:''),
                    onClick: _withModifiers(($event: any) => (checkRoles(item,index)), ["stop"])
                  }, [
                    (item.user==undefined )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[3] || (_cache[3] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1),
                          _createElementVNode("span", null, "官方", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (item.user!=undefined && item.userId!='0')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("img", {
                              src: _unref(proxy).getimgUrl + item.user.avatar,
                              alt: ""
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(item.user.nickName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: _unref(proxy).getimgUrlVoice + item.avatar,
                          alt: ""
                        }, null, 8, _hoisted_15)
                      ]),
                      (!item.isPlaying)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "",
                              onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                            }, null, 8, _hoisted_17)
                          ]))
                        : _createCommentVNode("", true),
                      (item.isPlaying)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "",
                              onClick: _withModifiers(($event: any) => (topause(index)), ["stop"])
                            }, null, 8, _hoisted_19)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(item.intro), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1))
                  ], 12, _hoisted_8))
                }), 128))
              ]),
              _createElementVNode("audio", {
                src: _unref(proxy).getimgUrlVoice + '/' + urlListening.value,
                controls: "",
                ref_key: "audioRef",
                ref: audioRef,
                onEnded: updateCurrentTime,
                style: {"display":"none"}
              }, null, 40, _hoisted_22)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showRoleList.value.length==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[5] || (_cache[5] = [
            _createElementVNode("img", { src: _imports_3 }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", {
          class: "btnNo",
          onClick: _withModifiers(closeBox, ["stop"])
        }, "取消"),
        _createElementVNode("span", {
          class: "btnOk",
          onClick: _withModifiers(handleClose, ["stop"])
        }, "确定")
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_26, _cache[6] || (_cache[6] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_4,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ])
  ]))
}
}

})